import React, { useState, useEffect, useImperativeHandle } from "react";
import i18n from "../../Services/i18n";
import styles from "./ChangeUsernameModal.module.css";
import { addToast } from "../../Services/toastService";

const ChangeUsernameModal = ({ ref, currentEmail }) => {
  const EMAIL_RGX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useImperativeHandle(ref, () => ({
    isValid() {
      if (!EMAIL_RGX.test(newEmail)) {
        addToast(i18n.t("RegisterForm.Error.InvalidEmail"), "BACKENDERROR", "ERROR", true);
        return false;
      }
      return true;
    },
    newEmail() {
      return newEmail;
    },
  }));

  return (
    <>
      <div className={styles.container}>
        <p>
          <strong>{i18n.t("ConfirmChangeUsername.FirstParagraph")}</strong>
        </p>
        <p>{i18n.t("ConfirmChangeUsername.SecondParagraph")}</p>

        <div className={styles.row}>
          <div className={styles.leftSectionLabelKey}>
            <label>{i18n.t("ConfirmChangeUsername.OldEmail")}: </label>
          </div>
          <div className={styles.leftSectionLabelValue}>
            <input readOnly disabled type="text" className={styles.input} value={currentEmail} />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.leftSectionLabelKey}>
            <label>{i18n.t("ConfirmChangeUsername.NewEmail")}: </label>
          </div>
          <div className={styles.leftSectionLabelValue}>
            <input
              type="text"
              className={styles.input}
              value={newEmail}
              onChange={(e) => {
                setNewEmail(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangeUsernameModal;
